import { makeNetworkRequest } from "./networkUtils";

export const triggerPrivacyPreferencesFunction = async (httpRequestType, postData) => {
    let fullEndpoint = `/privacyPreferences`;
    let response = await makeNetworkRequest(httpRequestType, fullEndpoint, null, postData);
    if(response) {
        return response;
    } else {
        return false;
    }
};

export const getPrivacyPreferences = async (email) => {
    let privacyPreferences = await triggerPrivacyPreferencesFunction("post", { email });
    let result = false;
    if(privacyPreferences && privacyPreferences.length > 0) {
        result = privacyPreferences[0];
    }
    return result;
};
  
export const updatePrivacyPreferences = async (privacyPreferences) => {
    let updatedPrivacyPreferences = await triggerPrivacyPreferencesFunction("post", privacyPreferences);
    let result = false;
    if(updatedPrivacyPreferences) {
        result = true;
    }
    return result;
};